import { render, staticRenderFns } from "./AddManualPointPopup.vue?vue&type=template&id=61488e21&scoped=true"
import script from "./AddManualPointPopup.vue?vue&type=script&lang=js"
export * from "./AddManualPointPopup.vue?vue&type=script&lang=js"
import style0 from "./AddManualPointPopup.vue?vue&type=style&index=0&id=61488e21&prod&lang=scss&scoped=true"
import style1 from "./AddManualPointPopup.vue?vue&type=style&index=1&id=61488e21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61488e21",
  null
  
)

export default component.exports